import { render, staticRenderFns } from "./OrderSubmitResult.vue?vue&type=template&id=1c05fb30&scoped=true"
import script from "./OrderSubmitResult.vue?vue&type=script&lang=js"
export * from "./OrderSubmitResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05fb30",
  null
  
)

export default component.exports